module.exports = __webpack_public_path__ + "static/media/Calculator.d79d591c.gif";